// not-found.component.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.sass'],
    standalone: false
})
export class NotFoundComponent {
  constructor(private router: Router) {}
}
